/* ── Premium toast notification system ── */

var ICONS = {
    success: '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 9.5L7.8 11.8L12.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    error: '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M6.5 6.5L11.5 11.5M11.5 6.5L6.5 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    warning: '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1.5L17 16H1L9 1.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M9 7V10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="9" cy="13" r="0.75" fill="currentColor"/></svg>',
    info: '<svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M9 8V13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="9" cy="5.5" r="0.75" fill="currentColor"/></svg>'
};

var CLOSE_SVG = '<svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3L11 11M11 3L3 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

var DURATIONS = {
    success: 5000,
    error: 8000,
    warning: 6000,
    info: 5000
};

var MAX_VISIBLE = 5;
var counter = 0;
var toasts = new Map();
var container = null;

function getContainer() {
    if (container && document.body.contains(container)) return container;
    container = document.createElement('div');
    container.id = 'st-toast-container';
    container.className = 'st-toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('role', 'status');
    document.body.appendChild(container);
    return container;
}

function createToastEl(opts) {
    var el = document.createElement('div');
    el.className = 'st-toast st-toast--' + opts.type;
    el.setAttribute('role', opts.type === 'error' ? 'alert' : 'status');
    el.setAttribute('aria-live', opts.type === 'error' ? 'assertive' : 'polite');
    el.style.setProperty('--toast-duration', opts.duration + 'ms');

    // Icon
    var iconEl = document.createElement('div');
    iconEl.className = 'st-toast-icon';
    iconEl.innerHTML = ICONS[opts.type] || ICONS.info;
    el.appendChild(iconEl);

    // Body
    var bodyEl = document.createElement('div');
    bodyEl.className = 'st-toast-body';
    var msgEl = document.createElement('p');
    msgEl.className = 'st-toast-message';
    msgEl.textContent = opts.message;
    bodyEl.appendChild(msgEl);

    // Optional subtitle
    if (opts.subtitle) {
        var subtitleEl = document.createElement('p');
        subtitleEl.className = 'st-toast-subtitle';
        subtitleEl.textContent = opts.subtitle;
        bodyEl.appendChild(subtitleEl);
    }

    // Optional action link
    if (opts.action) {
        // A url-less <a> is unfocusable and ignores Enter — onClick-only
        // actions must be real buttons to be keyboard-operable.
        var actionEl = document.createElement(opts.action.url ? 'a' : 'button');
        actionEl.className = 'st-toast-action';
        if (opts.action.url) {
            actionEl.href = opts.action.url;
            actionEl.target = '_blank';
            actionEl.rel = 'noopener noreferrer';
        } else {
            actionEl.type = 'button';
        }
        actionEl.textContent = opts.action.label;
        if (typeof opts.action.onClick === 'function') {
            actionEl.addEventListener('click', opts.action.onClick);
        }
        bodyEl.appendChild(actionEl);
    }

    el.appendChild(bodyEl);

    // Undo button
    if (typeof opts.undo === 'function') {
        var undoBtn = document.createElement('button');
        undoBtn.className = 'st-toast-undo';
        undoBtn.type = 'button';
        undoBtn.textContent = 'Undo';
        undoBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            opts.undo();
            dismissToast(opts.id, true);
            showToast({ type: 'info', message: 'Action undone', duration: 2500 });
        });
        el.appendChild(undoBtn);
    }

    // Close button
    if (opts.dismissible !== false) {
        var closeBtn = document.createElement('button');
        closeBtn.className = 'st-toast-close';
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Dismiss notification');
        closeBtn.innerHTML = CLOSE_SVG;
        closeBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            dismissToast(opts.id);
        });
        el.appendChild(closeBtn);
    }

    // Progress bar
    if (opts.duration > 0) {
        var progress = document.createElement('div');
        progress.className = 'st-toast-progress';
        el.appendChild(progress);
    }

    return el;
}

function startTimer(instance) {
    if (instance.duration <= 0) return;
    instance.remaining = instance.duration;
    instance.startTime = performance.now();

    function tick(now) {
        if (instance.dismissed) return;
        if (instance.paused) {
            instance.rafId = requestAnimationFrame(tick);
            return;
        }
        var elapsed = now - instance.startTime;
        if (elapsed >= instance.remaining) {
            dismissToast(instance.id);
            return;
        }
        instance.rafId = requestAnimationFrame(tick);
    }

    instance.rafId = requestAnimationFrame(tick);
}

function pauseTimer(instance) {
    if (instance.paused || instance.duration <= 0) return;
    instance.paused = true;
    instance.remaining = Math.max(0, instance.remaining - (performance.now() - instance.startTime));
    instance.el.classList.add('st-toast--paused');
}

function resumeTimer(instance) {
    if (!instance.paused || instance.duration <= 0) return;
    instance.paused = false;
    instance.startTime = performance.now();
    instance.el.classList.remove('st-toast--paused');
}

function setupHoverPause(instance) {
    instance.el.addEventListener('mouseenter', function () { pauseTimer(instance); });
    instance.el.addEventListener('mouseleave', function () { resumeTimer(instance); });
    instance.el.addEventListener('focusin', function () { pauseTimer(instance); });
    instance.el.addEventListener('focusout', function () { resumeTimer(instance); });
}

function setupSwipeDismiss(instance) {
    var startX = 0;
    var currentX = 0;
    var swiping = false;

    instance.el.addEventListener('touchstart', function (e) {
        var touch = e.touches[0];
        startX = touch.clientX;
        currentX = startX;
        swiping = true;
        instance.el.style.transition = 'none';
    }, { passive: true });

    instance.el.addEventListener('touchmove', function (e) {
        if (!swiping) return;
        currentX = e.touches[0].clientX;
        var dx = currentX - startX;
        if (dx < 0) dx = 0; // only swipe right
        instance.el.style.transform = 'translateX(' + dx + 'px)';
        instance.el.style.opacity = String(Math.max(0, 1 - dx / 200));
    }, { passive: true });

    instance.el.addEventListener('touchend', function () {
        if (!swiping) return;
        swiping = false;
        var dx = currentX - startX;
        if (dx > 80) {
            dismissToast(instance.id);
        } else {
            instance.el.style.transition = 'transform 0.2s ease, opacity 0.2s ease';
            instance.el.style.transform = '';
            instance.el.style.opacity = '';
        }
    }, { passive: true });
}

function setupKeyboard(instance) {
    instance.el.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            e.stopPropagation();
            dismissToast(instance.id);
        }
    });
}

function dismissToast(id, immediate) {
    var instance = toasts.get(id);
    if (!instance || instance.dismissed) return;
    instance.dismissed = true;

    if (instance.rafId) cancelAnimationFrame(instance.rafId);

    if (immediate) {
        if (instance.el.parentNode) instance.el.parentNode.removeChild(instance.el);
        toasts.delete(id);
        return;
    }

    instance.el.classList.add('st-toast--exiting');

    var onEnd = function () {
        if (instance.el.parentNode) instance.el.parentNode.removeChild(instance.el);
        toasts.delete(id);
    };

    instance.el.addEventListener('animationend', onEnd, { once: true });
    // Fallback in case animationend doesn't fire (reduced motion)
    setTimeout(onEnd, 350);
}

function enforceMax() {
    if (toasts.size <= MAX_VISIBLE) return;
    // Dismiss oldest (first inserted)
    var oldest = toasts.keys().next().value;
    if (oldest) dismissToast(oldest);
}

function showToast(opts) {
    var id = opts.id || ('toast-' + Date.now() + '-' + (++counter));
    var type = opts.type || 'info';
    var duration = typeof opts.duration === 'number' ? opts.duration : (DURATIONS[type] || 5000);

    // Deduplicate by id
    if (opts.id && toasts.has(opts.id)) {
        dismissToast(opts.id, true);
    }

    var config = {
        id: id,
        type: type,
        message: opts.message || '',
        subtitle: opts.subtitle || null,
        action: opts.action || null,
        duration: duration,
        undo: opts.undo || null,
        dismissible: opts.dismissible !== false
    };

    var el = createToastEl(config);
    var instance = {
        id: id,
        el: el,
        duration: duration,
        remaining: duration,
        startTime: 0,
        paused: false,
        dismissed: false,
        rafId: null
    };

    toasts.set(id, instance);
    getContainer().appendChild(el);

    setupHoverPause(instance);
    setupSwipeDismiss(instance);
    setupKeyboard(instance);
    startTimer(instance);
    enforceMax();

    return id;
}

// ── Public API ──
export var toast = {
    show: showToast,
    success: function (message, opts) {
        return showToast(Object.assign({ type: 'success', message: message }, opts || {}));
    },
    error: function (message, opts) {
        return showToast(Object.assign({ type: 'error', message: message }, opts || {}));
    },
    info: function (message, opts) {
        return showToast(Object.assign({ type: 'info', message: message }, opts || {}));
    },
    warning: function (message, opts) {
        return showToast(Object.assign({ type: 'warning', message: message }, opts || {}));
    },
    dismiss: function (id) {
        dismissToast(id);
    },
    dismissAll: function () {
        toasts.forEach(function (_, id) {
            dismissToast(id);
        });
    }
};

// Expose globally for Razor views and inline scripts
window.Stackora = window.Stackora || {};
window.Stackora.toast = toast;
